// src/LanguageSwitcher.tsx

import React, { startTransition } from 'react';
import { useTranslation } from 'react-i18next';
import { normalizeLang } from '../utils/dataResolver';
import { persistAppLang } from '../i18n';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();
  const active = normalizeLang(i18n.resolvedLanguage || i18n.language);

  const setLang = (lng: 'pl' | 'en') => {
    if (active === lng) return;
    persistAppLang(lng);
    // Full-tree re-render — keep it off the critical input path for INP.
    startTransition(() => {
      void i18n.changeLanguage(lng);
    });
  };

  return (
    <div className="flex items-center">
      <button
        type="button"
        onClick={() => setLang('pl')}
        className={`px-2 py-1 text-sm rounded-md ${active === 'pl' ? 'font-bold text-white' : 'text-gray-400'}`}
        aria-pressed={active === 'pl'}
      >
        PL
      </button>
      <span className="text-gray-500 mx-1">|</span>
      <button
        type="button"
        onClick={() => setLang('en')}
        className={`px-2 py-1 text-sm rounded-md ${active === 'en' ? 'font-bold text-white' : 'text-gray-400'}`}
        aria-pressed={active === 'en'}
      >
        EN
      </button>
    </div>
  );
};

export default LanguageSwitcher;
